module.exports = __webpack_public_path__ + "img/occupation-cart-head-2.91822873.png";